export default __webpack_public_path__ + "static/media/close-gallery.70985559.svg";